import $ from 'jquery';
//import nunjucks from 'nunjucks';
//import sweetalert from 'sweetalert';
//import preloadNunjucks from '../preload/nunjucks';
//var nunjucksEnv = preloadNunjucks();
//import settings from '../settings';

export default class Ajax {

	constructor() {
		//this._poppedup = false;
		//this._loggingIn = false;
		//this._qRequests = [];

		$(document).ajaxComplete(this._callback.bind(this));
	}

	/*
	_popupAuth() {
		console.log('popping up auth')

		this._poppedup = true;

		sweetalert({
			title             : "Log in",
			text              : nunjucksEnv.render('html/ui/login.html'),
			html			  : true,
			//type              : "info",
			showCancelButton  : true,
			confirmButtonText : "Login",
			closeOnConfirm    : false
		});

		$('.sweet-alert .confirm').on('click', (ev) => {

			console.log('CAUGHT CLICK');

			ev.preventDefault();

			let email = $('form__session_expired .form__login_email'),
				password = $('form__session_expired .form__login_password'),
				objLogin = {
					email: email.val(),
					password: password.val()
				};

			this._loggingIn = true;

			sweetalert.resetInputError();

			$.ajax({
				headers   : settings.api_headers,
				url 	  : '/auth/login',
				type 	  : 'POST',
				data 	  : objLogin
			})
			.fail(() => {
				console.log('FAILED')
				sweetalert.showInputError('Sorry, your credentials were not correct.')
				this._loggingIn = false;
			})
			.done(() => {
				console.log('SUCCESS')
				this._qRequests.forEach((request) => {
					$.ajax(request);
				});
				this._qRequests = [];
				sweetalert.close();
				this._loggingIn = false;
			});
		});
	}
	*/

	_callback(event, jqXHR, ajaxOptions) {
		//if (this._loggingIn) return;
		//console.log('caught ajax request with status', jqXHR.status)
		if (401 != jqXHR.status) return;

		return window.location.href = '/auth/login';

		/*
		console.log('processing it')
		this._qRequests.push(jqXHR);
		console.log('seeing if we have already popped up:', this._poppedup);
		if (this._poppedup) return;

		console.log('asking for auth')
		this._popupAuth();
		*/
	}
};
